module.exports = __webpack_public_path__ + "media/images/logoip-bd84b5f657b7d4eb5e112a082f57a6e0.png";